<template>
    <div class="finances_section">
        <i class="uis uis-euro-circle"></i>
        <h2>Finances</h2>
        <h2>This section is under construction</h2>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.finances_section {
    padding-top: 2rem;

    i {
        font-size: 2rem;
    }
}
</style>